import React, { useState } from "react";
import CookieConsent from "react-cookie-consent";
import { isMobile } from "react-device-detect";
import { CookieModal } from "./CookieModal";

export const CookieBanner = () => {
  const [visible, setVisibility] = useState(false);
  const closeModal = () => {
    setVisibility(false);
  };
  return (
    <>
      <CookieModal visible={visible} closeModal={closeModal} />
      <CookieConsent
        disableButtonStyles
        location="bottom"
        buttonText="Continuar e fechar"
        buttonClasses="btn text-light m-3"
        buttonStyle={{ backgroundColor: "#114f8c" }}
        containerClasses="align-items-center"
        contentStyle={{ margin: 0 }}
        style={{
          backgroundColor: "#1976d2",
          paddingLeft: isMobile ? 0 : 50,
          paddingRight: isMobile ? 0 : 200,
          paddingBottom: 0,
          paddingTop: 10,
          minHeight: 50 + 20 + 4,
        }}
        expires={150}
        onAccept={closeModal}
      >
        <p
          className={`${
            isMobile ? "text-center small" : "text-left"
          } text-light my-0`}
        >
          Utilizamos cookies para coletar estatísticas de uso do site. Acesse as{" "}
          <span
            className="text-light"
            onClick={() => {
              setVisibility(!visible);
            }}
          >
            <u>definições de cookies</u>
          </span>{" "}
          para entender mais a respeito. Ao continuar, você declara estar ciente
          sobre a nossa política de cookies.
        </p>
      </CookieConsent>
    </>
  );
};
